'use strict';
const flattenIdeas = require('@mindmup/mapjs-core/src/content/flatten-ideas'),
	goldAssetImpl = require('./gold-asset');

module.exports = function serializeContent(content, s3FileModel, resourceManager, options) {
	if (!options || !options.uploadAssets) {
		return Promise.resolve(JSON.stringify(content, null, 2));
	}
	if (!resourceManager || !s3FileModel) {
		return Promise.reject('invalid-args');
	}
	if (!content) {
		return Promise.resolve();
	}
	const unpackResourceUrls = (idea) => {
			const icon = idea && idea.attr && idea.attr.icon,
				iconUrl = icon && icon.url,
				internalPrefix = 'internal:',
				resourceUrl = iconUrl && resourceManager.getResource(iconUrl);
			if (resourceUrl && resourceUrl !== iconUrl && iconUrl.indexOf(internalPrefix) === 0) {
				icon.url = resourceUrl;
			};
		},
		fileId = options && options.fileId,
		goldAsset = options && options.goldAsset || goldAssetImpl,
		uploadPromises = flattenIdeas(content).map((idea) => {
			unpackResourceUrls(idea);
			return goldAsset.uploadAssets(fileId, idea, s3FileModel);
		});

	return Promise.all(uploadPromises).then(function () {
		delete content.resources;
		return JSON.stringify(content, null, 2);
	});
};
